// src/pages/events/Ashura.jsx
import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const Ashura = () => {
  return (
    <>
      <Helmet>
        <title>Ashura – The Day of Sacrifice | Ziyarat Guide</title>
        <meta
          name="description"
          content="Learn about Ashura, the day of Imam Hussain’s (AS) martyrdom in Karbala. Discover its significance, observances, and timeless message of justice and faith."
        />
        <meta
          property="og:title"
          content="Ashura – The Day of Sacrifice | Ziyarat Guide"
        />
        <meta
          property="og:description"
          content="Ashura commemorates the martyrdom of Imam Hussain (AS) in Karbala — a powerful reminder of faith, courage, and justice."
        />
        <meta
          property="og:image"
          content="https://ziyaratguide.com/static/media/566294861b2d1.17213b80b0591976d762.jpg"
        />
        <meta property="og:type" content="article" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <div className="imam-page">
        <div className="imam-content">
          <h1 className="page-title">Ashura Commemoration</h1>

          <div className="content-section">
            <img
              src="https://ziyaratguide.com/static/media/566294861b2d1.17213b80b0591976d762.jpg"
              alt="Ashura Procession"
              className="imam-image"
            />

            <h2>Significance of Ashura</h2>
            <p>
              <strong>A Day of Reflection:</strong> Ashura is a day of deep
              sorrow and remembrance, marking the martyrdom of Imam Hussain
              (PBUH) in Karbala. Millions of Muslims around the world observe
              this day, reflecting on the sacrifices made in the struggle for
              justice and righteousness.
            </p>

            <h2>Observances & Traditions</h2>
            <p>
              On Ashura, followers participate in mourning processions, recite
              elegies (Noha), and engage in prayers and reflection. It is a time
              to connect spiritually, remember the principles Imam Hussain stood
              for, and renew commitment to justice and moral courage.
            </p>

            <h2>How to Observe Ashura Personally</h2>
            <ol>
              <li>
                <strong>Learn the Story:</strong> Understand the events of
                Karbala, the sacrifices, and the unwavering principles Imam
                Hussain embodied.
              </li>
              <li>
                <strong>Participate in Mourning:</strong> Attend processions or
                virtual gatherings, or listen to Noha recitations at home.
              </li>
              <li>
                <strong>Reflect & Pray:</strong> Use this day to contemplate your
                own actions, pray for guidance, and commit to standing for truth
                and justice.
              </li>
              <li>
                <strong>Help Others:</strong> Acts of charity and service are
                encouraged as a way to honor Imam Hussain’s values.
              </li>
              <li>
                <strong>Share Knowledge:</strong> Discuss the significance of
                Ashura with family and community to keep the story alive for
                future generations.
              </li>
            </ol>

            <h3>A Small Reflection</h3>
            <blockquote>
              “On this day, I remember the courage of Imam Hussain and the
              sacrifices of Karbala. May I strive to uphold truth and justice in
              my life, inspired by their unwavering faith.”
            </blockquote>
          </div>
        </div>

        {/* Sidebar Navigation */}
        <aside className="imam-sidebar">
          <h2>Explore More Events</h2>
          <ul>
            <li>
              <Link to="/events/arbaeen">Arbaeen</Link>
            </li>
          </ul>
        </aside>
      </div>
    </>
  );
};

export default Ashura;
